var map = {
	"./Spin torre M_Interactive LightMix0001.webp": 236,
	"./Spin torre M_Interactive LightMix0002.webp": 237,
	"./Spin torre M_Interactive LightMix0003.webp": 238,
	"./Spin torre M_Interactive LightMix0004.webp": 239,
	"./Spin torre M_Interactive LightMix0005.webp": 240,
	"./Spin torre M_Interactive LightMix0006.webp": 241,
	"./Spin torre M_Interactive LightMix0007.webp": 242,
	"./Spin torre M_Interactive LightMix0008.webp": 243,
	"./Spin torre M_Interactive LightMix0009.webp": 244,
	"./Spin torre M_Interactive LightMix0010.webp": 245,
	"./Spin torre M_Interactive LightMix0011.webp": 246,
	"./Spin torre M_Interactive LightMix0012.webp": 247,
	"./Spin torre M_Interactive LightMix0013.webp": 248,
	"./Spin torre M_Interactive LightMix0014.webp": 249,
	"./Spin torre M_Interactive LightMix0015.webp": 250,
	"./Spin torre M_Interactive LightMix0016.webp": 251,
	"./Spin torre M_Interactive LightMix0017.webp": 252,
	"./Spin torre M_Interactive LightMix0018.webp": 253,
	"./Spin torre M_Interactive LightMix0019.webp": 254,
	"./Spin torre M_Interactive LightMix0020.webp": 255,
	"./Spin torre M_Interactive LightMix0021.webp": 256,
	"./Spin torre M_Interactive LightMix0022.webp": 257,
	"./Spin torre M_Interactive LightMix0023.webp": 258,
	"./Spin torre M_Interactive LightMix0024.webp": 259,
	"./Spin torre M_Interactive LightMix0025.webp": 260,
	"./Spin torre M_Interactive LightMix0026.webp": 261,
	"./Spin torre M_Interactive LightMix0027.webp": 262,
	"./Spin torre M_Interactive LightMix0028.webp": 263,
	"./Spin torre M_Interactive LightMix0029.webp": 264,
	"./Spin torre M_Interactive LightMix0030.webp": 265,
	"./Spin torre M_Interactive LightMix0031.webp": 266,
	"./Spin torre M_Interactive LightMix0032.webp": 267,
	"./Spin torre M_Interactive LightMix0033.webp": 268,
	"./Spin torre M_Interactive LightMix0034.webp": 269,
	"./Spin torre M_Interactive LightMix0035.webp": 270,
	"./Spin torre M_Interactive LightMix0036.webp": 271,
	"./Spin torre M_Interactive LightMix0037.webp": 272,
	"./Spin torre M_Interactive LightMix0038.webp": 273,
	"./Spin torre M_Interactive LightMix0039.webp": 274,
	"./Spin torre M_Interactive LightMix0040.webp": 275,
	"./Spin torre M_Interactive LightMix0041.webp": 276,
	"./Spin torre M_Interactive LightMix0042.webp": 277,
	"./Spin torre M_Interactive LightMix0043.webp": 278,
	"./Spin torre M_Interactive LightMix0044.webp": 279,
	"./Spin torre M_Interactive LightMix0045.webp": 280,
	"./Spin torre M_Interactive LightMix0046.webp": 281,
	"./Spin torre M_Interactive LightMix0047.webp": 282,
	"./Spin torre M_Interactive LightMix0048.webp": 283,
	"./Spin torre M_Interactive LightMix0049.webp": 284,
	"./Spin torre M_Interactive LightMix0050.webp": 285,
	"./Spin torre M_Interactive LightMix0051.webp": 286,
	"./Spin torre M_Interactive LightMix0052.webp": 287,
	"./Spin torre M_Interactive LightMix0053.webp": 288,
	"./Spin torre M_Interactive LightMix0054.webp": 289,
	"./Spin torre M_Interactive LightMix0055.webp": 290,
	"./Spin torre M_Interactive LightMix0056.webp": 291,
	"./Spin torre M_Interactive LightMix0057.webp": 292,
	"./Spin torre M_Interactive LightMix0058.webp": 293,
	"./Spin torre M_Interactive LightMix0059.webp": 294,
	"./Spin torre M_Interactive LightMix0060.webp": 295,
	"./Spin torre M_Interactive LightMix0061.webp": 296,
	"./Spin torre M_Interactive LightMix0062.webp": 297,
	"./Spin torre M_Interactive LightMix0063.webp": 298,
	"./Spin torre M_Interactive LightMix0064.webp": 299,
	"./Spin torre M_Interactive LightMix0065.webp": 300,
	"./Spin torre M_Interactive LightMix0066.webp": 301,
	"./Spin torre M_Interactive LightMix0067.webp": 302,
	"./Spin torre M_Interactive LightMix0068.webp": 303,
	"./Spin torre M_Interactive LightMix0069.webp": 304,
	"./Spin torre M_Interactive LightMix0070.webp": 305,
	"./Spin torre M_Interactive LightMix0071.webp": 306,
	"./Spin torre M_Interactive LightMix0072.webp": 307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 235;